'use client';

import { useEffect, useState } from 'react';

import { Modal } from '@/components/Modal';
import { CheckLocale } from '@/components/modals/CheckLocale';
import { isTimeLeft, timestampByUTC } from '@/helpers/dateTime';
import { isMatchLanguage } from '@/helpers/transl';
import { STORAGE, useGetCommonStore, useLocalStorageStore } from '@/store';

const ONE_DAY = 24 * 60 * 60 * 1000;
const THIRTY_DAYS = 30 * ONE_DAY;

export const useComparingLanguagesWithUserCountry = (locale: string) => {
  const useCommonStore = useGetCommonStore();

  const user = useCommonStore.use.user();

  const [isOpenCheckLocale, setIsOpenCheckLocale] = useState(false);

  useEffect(() => {
    if (user?.country == null) return;

    const lastApproveLanguage = useLocalStorageStore
      ?.getState()
      .get(STORAGE.APPROVE_LANGUAGE_DATE, null);

    const timeToShow =
      !lastApproveLanguage ||
      (lastApproveLanguage && isTimeLeft(lastApproveLanguage, THIRTY_DAYS));

    if (timeToShow && !isMatchLanguage(user.country, locale)) {
      setIsOpenCheckLocale(true);

      useLocalStorageStore
        ?.getState()
        ?.replace(STORAGE.APPROVE_LANGUAGE_DATE, timestampByUTC());
    }
  }, [user?.country, locale]);

  return isOpenCheckLocale ? (
    <Modal>
      <CheckLocale onClose={() => setIsOpenCheckLocale(false)} />
    </Modal>
  ) : null;
};
